<template>
  <div></div>
</template>

<script>
import i18n from "@/traductions/config";
import axios from "@/axiosConnection";

export default {
  name: "Logout",
  mounted() {
    // Si on est loggé via le form classique
    if (this.$store.getters["auth/token"]) {
      this.$store.dispatch("auth/logout").then(() => {
        this.$toastr.success(this.$i18n.t("success.security.logged_out"));

        // Navigate back to home
        this.$router.push({ path: "/" });
      });
    }

    // Logout OKTA
    else {
      // Api Request
      axios
        .get(`logout`)
        .then(response => {
          // Si le serveur a bien déconnecté le user d'OKTA, alors on détruit aussi la session en front
          this.$auth.logout().then(() => {
            this.$store.dispatch("auth/setAuthenticated", false);

            // Navigate back to home
            this.$router.push({ path: "/" });
          });
        })
        .catch(error => {
          toastr.error("Impossible de vous déconnecter, veuillez réessayer");

          // Navigate back to home
          this.$router.push({ path: "/" });
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Security/logout.vue